import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import axios from 'axios';
import { apiMobileUrl } from '@/config';
import Drip from 'drip';
import User from 'drip/user';
import EvokeYoda from '@/utils/yoda';
import { isProd } from '@/config';
import { ajaxErrorProcess, isCrawlEnabled, ajaxSuccessLog } from './index';
import cookie from '@/drip/utils/cookie';
import mockApis from './mockApis';
import parseUrl from 'url-parse';
var _Drip$UA = Drip.UA,
  osName = _Drip$UA.osName,
  appVersion = _Drip$UA.appVersion;
var clientPlatform = ['mac', 'window', 'windows', 'unknown'].includes(osName) ? 'pc' : osName;
// 创建axios 实例
var instance = axios.create({
  baseURL: apiMobileUrl,
  timeout: 15000
});
var xorKey = 193056183;
var errorTips;
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  var _ref = Drip.constant || {},
    appType = _ref.appType,
    lng = _ref.lng,
    lat = _ref.lat,
    _ref$cityId = _ref.cityId,
    cityId = _ref$cityId === void 0 ? 1 : _ref$cityId;

  // 配置公共请求参数
  config.headers.common = config.headers.common || {};
  config.headers.common.sellChannel = appType;
  config.headers.common.cityId = cityId;
  config.headers.common.token = User.token || '';
  config.headers.common.uuid = Drip.User.uuid || '';
  if (lat) {
    config.headers.common.lat = lat;
  }
  if (lng) {
    config.headers.common.lng = lng;
  }
  if (lat && lng) {
    config.headers.common.latLng = "".concat(lat, ",").concat(lng);
  }

  // 猫眼app隐私信息合规：https://wiki.maoyan.com/pages/viewpage.action?pageId=235227528
  if (Drip.UA.IS_MAOYAN) {
    // 经度 保留5位小数
    config.headers.common.ax = Math.trunc((lng || 0) * 100000) ^ xorKey;
    // 纬度 保留5位小数
    config.headers.common.bx = Math.trunc((lat || 0) * 100000) ^ xorKey;
    delete config.headers.common.lng;
    delete config.headers.common.lat;
    delete config.headers.common.latLng;
  }
  config.headers.common.clientPlatform = clientPlatform;
  config.headers.common.clientVersion = appVersion;
  if (!isProd) {
    // test 环境使用请勿上线
    // config.headers.common['ufe-force'] = 'on'
    // config.headers[ 'swimlane' ] = '3803-atdgo'
  }
  config.params = config.params || {};
  config.params.optimus_risk_level = 71;
  config.params.optimus_code = 10;
  config.params.clientPlatform = Drip.UA.osName === 'ios' ? 2 : Drip.UA.osName === 'android' ? 1 : 3;

  /** mock */
  function arrIncludesUrl(arr, myurl) {
    for (var i = 0; i < arr.length; i++) {
      if (myurl.includes(arr[i])) {
        return true;
      }
    }
    return false;
  }
  if (cookie.get('mock') && arrIncludesUrl(mockApis, config.url)) {
    var _url = config.url.replace(/.*mock/, '');
    config.url = "".concat(location.origin, "/app/mock/879").concat(_url);
  } else {
    config.url = config.url.replace('/mock', '');
  }

  /** 灰度测试专用 */
  var isGray = location.search.includes('isshowgray=true');
  if (isGray) config.params.isshowgray = true;
  var isGray2 = location.search.includes('isshow2gray=true');
  if (isGray2) config.params.isshow2gray = true;
  /** 灰度测试专用 */

  config.data = config.data || '';
  return config;
}, function (error) {
  return Promise.reject(error);
});
// 添加响应拦截器
instance.interceptors.response.use(function (res) {
  var data = res.data,
    _res$headers = res.headers,
    headers = _res$headers === void 0 ? {} : _res$headers;

  // 接口报业务错误
  if (data && data.code !== 200 && !data.success) {
    setTimeout(function () {
      var _res$config, _window, _data$error;
      var requestUrl = (res === null || res === void 0 ? void 0 : (_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) || '';
      try {
        var urlObj = parseUrl(requestUrl);
        requestUrl = "".concat(urlObj.origin).concat(urlObj.pathname);
        requestUrl = requestUrl.replace(/(?:\/\d{2,})/g, '/*');
      } catch (e) {}
      (_window = window) === null || _window === void 0 ? void 0 : _window.owl('addError', {
        name: "\u63A5\u53E3\u4E1A\u52A1\u62A5\u9519 ".concat((data === null || data === void 0 ? void 0 : data.code) || (data === null || data === void 0 ? void 0 : (_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.code), " ").concat(requestUrl),
        msg: res
      }, {
        category: 'ajaxError',
        level: 'warn',
        combo: true
      });
    }, 0);
  } else {
    ajaxSuccessLog(res);
  }
  if (data && data.code === 406 && data.customData && data.customData.requestCode) {
    // mtsi 拦截
    EvokeYoda({
      requestCode: data.customData.requestCode
    }).then(function (isPass) {
      if (isPass) {
        // window.location.reload() 在安卓机中的app不生效 在路径中添加时间戳
        Drip.reload();
      }
    }).catch(function (err) {
      console.warn(err);
    });
  }
  // 部分 URL 不走处理逻辑
  var code = data.code,
    error = data.error;
  if (code === 403 || error && error.code === 403) {
    Drip.login({
      force: true
    }).then(function () {
      if (Drip.UA.isNative) {
        window.location.reload();
      }
    }).catch(function (err) {
      console.warn(err);
    });
    return;
  }
  var headerToken = headers['token'] || headers['TOKEN'];
  if (!User.isLogin && headerToken) User.setToken(headerToken);
  return data;
}, function (error) {
  ajaxErrorProcess(error);
  if (error.response && error.response.status === 401) {
    Drip.login({
      force: true
    }).then(function (res) {
      if (Drip.UA.isNative) {
        window.location.reload();
      }
    }).catch(function (err) {
      console.warn(err);
    });
  }
  return Promise.reject(error);
});
export default instance;